angular = require('angular')
class AutoupdateFactory
  @$injector: ['RestfulResource', '$http','config']
  constructor: (RestfulResource, $http, config)->    
    url = "#{config.api.url}/autoupdates/"    
    actions =       
     publish:
       url: "#{url}publish/:_id"
       method: "PUT" 
    Autoupdate = new RestfulResource("#{url}/:_id", {_id: "@_id"}, actions)      
    Autoupdate.prototype.$assignApp = (app)->
      exist = false
      @apps ?= []
      @apps.forEach (org)->
        if org.app?._id is app._id
          exist = true
      if not exist
        @apps.push
          app: app
          open: false
          system: false
    Autoupdate.prototype.$assignDevice = (device)->
      exist = false
      @devices ?= []
      @devices.forEach (org)->
        if org.device?._id is device._id
          exist = true
      if not exist
        @devices.push
          device: device
          status: "A"

    return Autoupdate
module.exports = AutoupdateFactory




// WEBPACK FOOTER //
// ./src/component/autoupdate/autoupdate.coffee